import script from "./LadyOfTheSea.vue?vue&type=script&setup=true&lang=ts"
export * from "./LadyOfTheSea.vue?vue&type=script&setup=true&lang=ts"

import "./LadyOfTheSea.vue?vue&type=style&index=0&id=4ff6aaa0&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ff6aaa0"]])

export default __exports__